const componentDocumentManagementPath = '{,*/}%ComponentName%/documentManagement';
export const documentManagementBundlesConfig = {
    parts: false,
    components: false,
    host: true,
};
export const documentManagementConventions = {
    patterns: [
        {
            part: 'hooks',
            path: `${componentDocumentManagementPath}/%ComponentName%.hooks.ts`,
        },
        {
            part: 'dataSchema',
            path: `${componentDocumentManagementPath}/%ComponentName%.dataSchema.ts`,
        },
        {
            part: 'metaData',
            path: `${componentDocumentManagementPath}/%ComponentName%.metadata.ts`,
        },
        {
            part: 'propertiesSchema',
            path: `${componentDocumentManagementPath}/%ComponentName%.propsSchema.ts`,
        },
        {
            part: 'componentDefinition',
            path: `${componentDocumentManagementPath}/%ComponentName%.definition.ts`,
        },
    ],
};
//# sourceMappingURL=documentManagement.js.map